"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () { return "\n&:focus {\n  outline: 0;\n}\n"; });
